export default __webpack_public_path__ + "static/media/noun_Sort_3095077.cf50bf5e.svg";